import styled from '@emotion/styled'
import MuiTextField from '@mui/material/TextField'
import MuiIconButton from '@mui/material/IconButton'
import MuiSelect from '@mui/material/Select'
import MuiRadio from '@mui/material/Radio'
import MuiCheckbox from '@mui/material/Checkbox'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { tokens } from '../../theme.js'
const colors = tokens.colors
const borderRadius = tokens.borderRadius

export const TextField = styled(MuiTextField)`
  & .MuiInputBase-root {
    color: ${colors.inputField.text};
    font: 400 14px/18px ${tokens.fonts.body};
    background: ${colors.inputField.background};
    border-radius: ${borderRadius.input};
  }
  & .MuiInputBase-input {
    padding: 8px 15px;
  }
  & .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${colors.inputField.border};
  }
  & .Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${colors.inputField.focusedBorder};
  }
  & .MuiInputLabel-root {
    font-family: ${tokens.fonts.body};
    color: ${colors.inputField.text};
  }
  & .MuiInputLabel-root.Mui-focused {
    color: ${colors.primary};
  }
  & .MuiFormHelperText-root {
    padding-top: 5px;
    font-size: 12px;
    color: ${colors.error};
    margin-left: 0;
  }
`

export const PasswordField = styled.div`
  position: relative;
  width: 100%;
  & .MuiTextField-root {
    width: 100%;
  }
  & .MuiIconButton-root {
    position: absolute;
    right: 4px;
    top: 4px;
    color: ${colors.text.muted};
  }
`
export const PasswordToggle = ({ shown, onClick, label }) => (
  <MuiIconButton type="button" onClick={onClick} aria-label={label} size="small">
    {shown ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
  </MuiIconButton>
)

const SelectInner = styled(MuiSelect)`
  width: 100%;
  font: 400 14px ${tokens.fonts.body};
  color: ${colors.inputField.text};
  background: ${colors.inputField.background};
  border-radius: ${borderRadius.input};
  & .MuiNativeSelect-select {
    padding: 9px 12px;
  }
  & .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${colors.sectionDivider};
  }
  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${colors.text.muted};
  }
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${colors.inputField.focusedBorder};
  }
  & .MuiSvgIcon-root {
    color: ${colors.text.muted};
  }
`
export function NativeSelect({ children, ...rest }) {
  const { 'data-testid': testId, ...props } = rest
  return (
    <SelectInner native IconComponent={ExpandMoreIcon} inputProps={{ 'data-testid': testId }} {...props}>
      {children}
    </SelectInner>
  )
}

const RadioInner = styled(MuiRadio)`
  padding: 0;
  &:hover {
    background-color: ${colors.primaryExtraLight};
  }
  &.Mui-disabled span {
    opacity: 0.5;
  }
`
const RadioOff = styled.span`
  display: block;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1.5px solid ${colors.text.muted};
  background: ${colors.white};
`
const RadioOn = styled.span`
  display: block;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${colors.primary};
  border: 6px solid ${colors.primary};
  box-shadow: inset 0 0 0 4px ${colors.white};
`
export function RadioButton(props) {
  return <RadioInner icon={<RadioOff />} checkedIcon={<RadioOn />} {...props} />
}

export const TableCheckbox = styled(MuiCheckbox)`
  padding: 0;
  color: ${colors.text.muted};
  & .MuiSvgIcon-root {
    width: 20px;
    height: 20px;
  }
  &.Mui-checked,
  &.MuiCheckbox-indeterminate {
    color: ${colors.primary};
  }
  &:hover {
    background-color: ${colors.primaryExtraLight};
  }
`

export const SearchInput = styled.input`
  width: 100%;
  height: 29px;
  box-sizing: border-box;
  padding: 0 12px;
  font: 400 13px ${tokens.fonts.body};
  color: ${colors.inputField.text};
  background: ${colors.inputField.background};
  border: 1px solid ${colors.inputField.border};
  border-radius: ${borderRadius.input};
  &::placeholder {
    color: ${colors.inputField.placeholder};
  }
  &:focus {
    outline: none;
    border-color: ${colors.inputField.focusedBorder};
  }
`

export const FieldLabel = styled.span`
  display: block;
  font: 500 11px/1.4 ${tokens.fonts.body};
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${colors.text.muted};
`

export const FilterChip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  white-space: nowrap;
  padding: 5px 12px;
  border-radius: ${borderRadius.button};
  font: 500 12px/1.2 ${tokens.fonts.body};
  border: 1px solid ${p => (p['aria-pressed'] ? colors.primary : colors.sectionDivider)};
  background: ${p => (p['aria-pressed'] ? colors.primaryExtraLight : colors.white)};
  color: ${p => (p['aria-pressed'] ? colors.primary : colors.text.body)};
  &:hover {
    border-color: ${colors.primary};
  }
`
